import { useTranslation } from 'next-i18next';
import { type MapTemplateType, MapTemplateTypeLocaleKey } from '@/types/MapTemplate';
import { cn } from '@/utils/tailwind.util';
type TypeBadgeProps = {
  type: string;
  className?: string;
};
export const TypeBadge = ({
  type,
  className
}: TypeBadgeProps) => {
  const {
    t
  } = useTranslation(['common']);
  return <div className={cn('flex items-center gap-0 rounded-[99px] bg-white bg-opacity-[0.72] backdrop-blur-[2px]', 'tablet-sm:px-2xs tablet-sm:py-[4px]', 'px-2xs py-3xs', className)} data-sentry-component="TypeBadge" data-sentry-source-file="TypeBadge.tsx">
      <p className="text-center text-caption-lg-semibold text-default">
        {t(MapTemplateTypeLocaleKey[type as MapTemplateType])}
      </p>
    </div>;
};